(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/level-header.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/level-header.js');

'use strict';

svs.numbergames.game.views.LevelHeader = Marionette.View.extend({
  ui: {
    levelInfo: '.js-level-info'
  },
  triggers: {
    'click @ui.levelInfo': 'clickedLevelInfo'
  },
  modelEvents: {
    'change:level': 'render'
  },
  template(data) {
    return svs.numbergames.game.templates.level_header(data);
  },
  onClickedLevelInfo() {
    let title;
    let text;
    if (this.model.get('isSystem')) {
      title = 'Välj system';
      text = 'Välj först vilken Kenonivå du vill skapa ett systemspel för. Nivån avgör vinstplanen. ' + 'Ju fler nummer du sedan markerar i brickan avgör hur många rader som skapas på den nivån. Antalet markeringar påverkar också vinstplanen.';
    } else {
      title = 'Vinstplan';
      text = 'Du kan själv välja vilken vinstplan du vill spela på. En lägre Kenonivå ökar chansen att vinna men toppvinsten är lägre. Keno 11 är den högsta nivån och ger de största vinsterna.';
    }
    const dialog = new svs.ui.dialog.Contextual({
      branding: svs.ui.dialog.branding.TUR,
      attachTo: this.getUI('levelInfo'),
      title,
      message: [{
        align: svs.ui.dialog.message.align.CENTER,
        type: svs.ui.dialog.message.TEXT,
        text
      }]
    });
    svs.ui.dialog.api.add(dialog);
  }
});

 })(window);